import { type NavigationLink } from '@/components/organisms/Navigation'
import { type TransportRequest } from '@/model/contexts/TransportRequestsProvider.tsx'

type RequestType = NavigationLink['value']

export const transportRequestType = (request: TransportRequest): RequestType | 'invalid_type' => {
  switch (request.status) {
    case 'pending':
      return 'pending'
    case 'assigned':
      return 'assigned'
    case 'allocated':
      return 'allocated'
    case 'on_board':
      return 'onboarded'
    case 'completed':
    case 'cancelled':
    case 'unfindable':
    case 'transferred':
      return 'completed'
    default:
      return 'invalid_type'
  }
}
